import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { t } from '../../../../modules/infra/i18n';
import Input from '../../../common/input';
import Money from '../../../common/money';
import { getDenominationTotal } from '../helpers';

const CountBillsTable = ({ fields }) => (
  <ReactTable
    className="c-table-new c-count-bills-table c-no-hover u-mb"
    data={fields.getAll()}
    minRows={0}
    showPagination={false}
    sortable={false}
    resizable={false}
    columns={[
      {
        id: 'billValue',
        Header: t('register:cash_register.bill_value_header'),
        accessor: item => item,
        Cell: row => (
          <span>
            <Money cents={row.value.denomination} precision={row.value.isCoin ? 2 : 0} />
            <span>
              {row.value.isCoin ? ` - ${t(row.value.nameKey)}` : t('register:cash_register.bill_suffix')}
            </span>
            <span
              display-if={row.value.isCoin}
              className="u-type--light u-co-gray"
            >
              {t('register:cash_register.coins_per_roll', { count: row.value.coinsPerRoll })}
            </span>
          </span>
        ),
        className: 'c-count-bills-table__cell',
      },
      {
        id: 'billsNo',
        Header: t('register:cash_register.nr_of_bills_header'),
        accessor: item => item,
        Cell: (row) => {
          const id = `billCounts[${row.index}].billsNo`;
          return (
            <div className="c-count-bills-input-group">
              <Input
                type="number"
                name={id}
                id={id}
                className="c-input c-input--white c-count-bills-input"
                placeholder="0"
              />
              <label
                htmlFor={id}
                className="c-count-bills-input__label"
              >
                {row.value.isCoin ? t('register:cash_register.coins_label') : t('register:cash_register.bills_label')}
              </label>
            </div>
          );
        },
        className: 'c-count-bills-table__cell',
      },
      {
        id: 'total',
        Header: t('register:cash_register.total_header'),
        headerStyle: { textAlign: 'right' },
        accessor: item => getDenominationTotal(item),
        Cell: row => (
          <div className="u-ml-auto">
            <Money cents={row.value} />
          </div>
        ),
        className: 'c-count-bills-table__cell',
      },
    ]}
  />
);

CountBillsTable.propTypes = {
  fields: PropTypes.object.isRequired,
};

export default CountBillsTable;
